import { render, staticRenderFns } from "./Singlecategory.vue?vue&type=template&id=73d46ee0&scoped=true&"
import script from "./Singlecategory.vue?vue&type=script&lang=js&"
export * from "./Singlecategory.vue?vue&type=script&lang=js&"
import style0 from "./Singlecategory.vue?vue&type=style&index=0&id=73d46ee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d46ee0",
  null
  
)

export default component.exports